import { Decorative } from "@faire/design-tokens";
import { getShouldUseZendeskSandbox } from "@faire/help-center-utils/serialized-data/getShouldUseZendeskSandbox";
import { getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import {
  StrictLocalizeFunction,
  backwardsCompatibleValues,
} from "@faire/web--source/common/localization/localize";

export const TABLET_GUTTER_SIZE =
  getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment() ? 24 : 40;
export const DESKTOP_GUTTER_SIZE = 56;

export type SupportParams = {
  topicId?: string;
  categoryId?: string;
  articleId?: string;
};

export const isHiddenSection = (sectionId: number | undefined) => {
  if (!sectionId) {
    return false;
  }
  const BRAND_HIDDEN_SECTION_ID = getShouldUseZendeskSandbox()
    ? 14638005358107
    : 360009975811;
  const RETAILER_HIDDEN_SECTION_ID = getShouldUseZendeskSandbox()
    ? 14638190793371
    : 360012034032;
  return [BRAND_HIDDEN_SECTION_ID, RETAILER_HIDDEN_SECTION_ID].includes(
    sectionId
  );
};

export const BRANDS_BANNER_DATA = (strictLocalize: StrictLocalizeFunction) => {
  return {
    color: Decorative.shade.green,
    title: strictLocalize({
      defaultMessage: "Selling on Faire",
      description: {
        text: "Title for the brand area on help center",
      },
    }),
    copy: strictLocalize({
      defaultMessage:
        "Learn more about shipping orders, contacting retailers, getting paid, and more.",
    }),
    imageURL:
      "https://cdn.faire.com/fastly/66c67dbccc5b62714fbd3e0062a9a1781085987a5c03ab2e50513ffa6b59795d.jpeg",
  };
};

export const RETAILERS_BANNER_DATA = (
  strictLocalize: StrictLocalizeFunction
) => {
  return {
    color: Decorative.icon.orange,
    title: strictLocalize({
      defaultMessage: "Buying on Faire",
      description: {
        text: "Title for the retailer area on help center",
      },
    }),
    copy: strictLocalize({
      defaultMessage:
        "Learn more about editing orders, contacting brands, reporting issues, and more.",
    }),
    imageURL:
      "https://cdn.faire.com/fastly/1a6b2136cbfe83154ba3615b8871d38c49e8e3426601a573f66d10137dca62c9.jpeg",
  };
};

export const READ_MORE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Read More",
    description: {
      text: "Default link in an article preview, goes to the full article",
    },
  });

export const IN_THIS_GUIDE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "In this guide",
    description: {
      text: "Title for a list of sections inside of an article",
    },
  });

export const BROWSE_ALL_TOPICS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Browse all topics",
    description: {
      text: "Title for a list containing all article topics",
    },
  });

export const QUICK_ACTIONS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Quick actions",
    description: {
      text: "Title to a section with shortcuts to all main Faire tasks straight from the help center",
    },
  });

export const viewAllText = (
  totalNumber: number,
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize(
    {
      defaultMessage: "View All ({totalNumber})",
      description: {
        text: "Button to display all elements from a list",
      },
    },
    backwardsCompatibleValues({ totalNumber })
  );
